import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getVehicleClassesList } from 'services/types';
import { Dialog, themes, SimpleForm, SimpleFormGroup, SimpleSelect } from 'libs/ui';
import { Content } from './class-set-form.styled';

export const ClassSetForm = (props) => {
  const { working } = props;
  const { t } = useTranslation();
  const [item, setItem] = useState('');

  /**
   * make action
   * @param {*} event
   */
  const submit = () => {
    const values = {
      vehicle_class: parseInt(item),
    };
    return props.action(values);
  };

  /**
   * change item
   * @param {*} event
   */
  const handleChange = (event) => {
    setItem(event.target.value);
  };

  const valid = !!item;

  return (
    <Dialog
      id="dialog-tariff-set-form"
      title={t('Изменить класс ТС у выбранных записей')}
      buttons={[
        { title: t('buttons.Отменить'), onClick: props.close },
        { title: t('buttons.Заменить'), onClick: submit, theme: themes.blue, disabled: !valid || working, working },
      ]}
    >
      <Content>
        <SimpleForm>
          <SimpleFormGroup>
            <label htmlFor="set-form-class">{t('dict_filter.Класс ТС')}</label>
            <SimpleSelect id="set-form-class" onChange={handleChange} value={item} name="vehicle_class">
              <option value="">{t('form.Не задано')}</option>
              {getVehicleClassesList()}
            </SimpleSelect>
          </SimpleFormGroup>
        </SimpleForm>
      </Content>
    </Dialog>
  );
};
